import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import type { LocationTypeDescription } from "@/Data/describeLocationType";
import locationTypes from "@/GeneratedFixtures/LocationTypes.json";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";

function isPopular(t: LocationTypeDescription): boolean {
  switch (t.type) {
    case LocationType.Warehouse:
      return true;
    case LocationType.DistributionWarehouse:
      return true;
    case LocationType.Residential:
      return true;
    case LocationType.ConstructionSite:
      return false;
    case LocationType.School:
      return false;
    case LocationType.TradeShow:
      return false;
    case LocationType.UniversityCollege:
      return false;
    case LocationType.Farm:
      return true;
    case LocationType.Mine:
      return false;
    case LocationType.Retail:
      return true;
    case LocationType.Hospitality:
      return false;
    case LocationType.Medical:
      return false;
    case LocationType.Airport:
      return false;
    case LocationType.SelfStorage:
      return false;
    case LocationType.Port:
      return false;
    case LocationType.Prison:
      return false;
    case LocationType.OtherLimitedAccess:
      return true;
    case LocationType.ReligiousSite:
      return false;
    case LocationType.Military:
      return false;
    case LocationType.Utility:
      return false;
  }
}

// Options carry their section as a `group`; the Dropdown buckets them under
// headers in first-appearance order, so Popular leads.
function buildOptions() {
  const all = locationTypes as LocationTypeDescription[];
  const popular = all.filter(isPopular);
  const other = all
    .filter((o) => !isPopular(o))
    .sort((a, b) => a.type.localeCompare(b.type));

  function option(t: LocationTypeDescription, group: string) {
    return {
      value: t.type,
      label: t.name,
      description: t.description,
      group,
    };
  }

  return [
    ...popular.map((o) => option(o, "Popular")),
    ...other.map((o) => option(o, "Other")),
  ];
}

interface LocationDropdownProps {
  locationType: LocationType | undefined;
  setLocationType: (_: LocationType) => void;
}

const options = buildOptions();

function LocationTypeDropdown(props: LocationDropdownProps) {
  return (
    <Dropdown
      value={props.locationType}
      onChange={(v) => props.setLocationType(v as LocationType)}
      options={options}
      data-testid="location-dropdown"
      placeholder="Select a location type"
      // Fills its column, like the postal code above it. A fixed token here
      // (it was "xl" = 384) overhangs the column once the panel is narrower
      // than the token, which is any screen below ~1000px.
      width="full"
    />
  );
}

export default LocationTypeDropdown;
